"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBasket = void 0;
var react_1 = require("react");
var react_query_1 = require("react-query");
var BasketProvider_1 = require("../context/BasketProvider");
var api_1 = require("../api");
var axios_1 = __importDefault(require("axios"));
var useBasket = function () {
    var _a = (0, react_1.useContext)(BasketProvider_1.BasketContext) || {}, basket = _a.basket, setBasket = _a.setBasket, catalogueId = _a.catalogueId;
    var create = (0, react_query_1.useMutation)(function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api_1.instance.catalogues.postBasket(__assign(__assign({}, body), { catalogueId: catalogueId }))];
                case 1: return [2 /*return*/, (_a.sent()).data];
            }
        });
    }); }, {
        onSuccess: function (res) { return setBasket(res); },
    });
    var update = (0, react_query_1.useMutation)(function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(basket === null || basket === void 0 ? void 0 : basket.basketToken))
                        throw new Error("No basket available to update");
                    return [4 /*yield*/, api_1.instance.catalogues.patchBasket(basket.basketToken, body)];
                case 1: return [2 /*return*/, (_a.sent())
                        .data];
            }
        });
    }); }, {
        onSuccess: function (res) { return setBasket(res); },
    });
    var fetch = (0, react_query_1.useQuery)(["fetchBasket", basket === null || basket === void 0 ? void 0 : basket.basketToken], function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(basket === null || basket === void 0 ? void 0 : basket.basketToken)) return [3 /*break*/, 2];
                    console.log("Refetching basket...");
                    return [4 /*yield*/, api_1.instance.catalogues.getBasket(basket.basketToken)];
                case 1: return [2 /*return*/, (_a.sent()).data];
                case 2: return [2 /*return*/, null];
            }
        });
    }); }, {
        onSuccess: function (data) {
            if ((data === null || data === void 0 ? void 0 : data.status) !== "processed") {
                setBasket(data || undefined);
            }
        },
        enabled: false,
    });
    var clear = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, update.mutateAsync({
                            items: [],
                        })];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    if (axios_1.default.isAxiosError(error_1) && ((_a = error_1.response) === null || _a === void 0 ? void 0 : _a.status) === 400) {
                        setBasket(undefined);
                        create.reset();
                        update.reset();
                    }
                    else {
                        throw error_1;
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return {
        basket: basket,
        create: create,
        update: update,
        clear: clear,
        fetch: fetch,
        reset: function () { return setBasket(undefined); },
        isSuccess: create.isSuccess || update.isSuccess,
        isError: create.isError || update.isError,
        error: create.error || update.error,
        isLoading: create.isLoading || update.isLoading,
    };
};
exports.useBasket = useBasket;
